import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@workspace/web-ui/components/select"
import { dateFilters } from "../../libs/filters"

interface DateFiltersProps {
    date: string
    setDate: React.Dispatch<React.SetStateAction<string>>
}

export const DateFilters = ({ date, setDate }: DateFiltersProps) => {
    return (
        <Select value={date} onValueChange={setDate}>
            <SelectTrigger className="w-fit button-primary !px-4 !py-3">
                <SelectValue placeholder="Date" />
            </SelectTrigger>
            <SelectContent>
                {dateFilters.map((filter) => (
                    <SelectItem 
                        key={filter.value} 
                        value={filter.value}
                    >
                        {filter.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}